import type { Moment } from '@this/src/lib/moment';
import moment from '@this/src/lib/moment';
import { observable } from 'mobx';

export interface BizEkinetReservationTotalResponseArgs {
  reservation_date: string;
  reservation_count: number;
  ai_operator_count: number;
  total_price: number;
  approved_at: string;
  approved_by: number;
}

export interface BizEkinetReservationTotalArgs {
  reservationDate: Moment;
  reservationCount: number;
  aiOperatorCount: number;
  totalPrice: number;
  approvedAt: Moment | null;
  approvedBy: number | null;
}

export const convertBizEkinetReservationTotalResponseToArgs = (
  response: BizEkinetReservationTotalResponseArgs
): BizEkinetReservationTotalArgs => ({
  reservationDate: moment(response.reservation_date),
  reservationCount: response.reservation_count,
  aiOperatorCount: response.ai_operator_count,
  totalPrice: response.total_price,
  approvedAt: response.approved_at ? moment(response.approved_at) : null,
  approvedBy: response.approved_by || null
});

export default class BizEkinetReservationTotal {
  @observable readonly reservationDate: Moment;
  @observable readonly reservationCount: number;
  @observable readonly aiOperatorCount: number;
  @observable readonly totalPrice: number;
  @observable approvedAt: Moment | null;
  @observable approvedBy: number | null;

  constructor(args: BizEkinetReservationTotalArgs) {
    this.reservationDate = args.reservationDate;
    this.reservationCount = args.reservationCount;
    this.aiOperatorCount = args.aiOperatorCount;
    this.totalPrice = args.totalPrice;
    this.approvedAt = args.approvedAt;
    this.approvedBy = args.approvedBy;
  }

  setApprovedAt(approvedAt?: string) {
    this.approvedAt = approvedAt ? moment(approvedAt) : null;
  }

  setApprovedBy(approvedBy?: number) {
    this.approvedBy = approvedBy || null;
  }
}
